import { combineReducers } from "redux";
import { RootAction } from "../types";

function options(state: string[] = [], action: RootAction): string[] {
    switch (action.type) {
      case 'FETCH_AUTOCOMPLETE_SUCCESS':
        return action.payload;
      case 'DO_SEARCH_REQUEST':
      case 'CANCEL_SEARCH':
        return [];
      default:
        return state;
    }
  }
  
  function loading(state: boolean = false, action: RootAction): boolean {
    switch (action.type) {
      case 'FETCH_AUTOCOMPLETE_REQUEST':
        return true;
  
      case 'FETCH_AUTOCOMPLETE_FAILURE':
      case 'FETCH_AUTOCOMPLETE_SUCCESS':
        return false;
  
      default:
        return state;
    }
  }
  

export const autocompleteReducer = combineReducers({
    loading,
    options
});

export default autocompleteReducer;



// WEBPACK FOOTER //
// ./src/reducers/autocompleteReducer.ts